<template>
  <!-- [sc-48351 / task 3] La barra sottile di CRM PLUS: menu su mobile,
       percorso della pagina, e chi è collegato. Le azioni stanno nella
       sidebar. -->
  <header class="plus-topbar">
    <button
      type="button"
      class="plus-topbar__hamburger"
      :aria-expanded="String(mobileOpen)"
      aria-label="Menu di navigazione"
      @click="$emit('toggle-mobile')"
    >
      <i
        class="fa-solid"
        :class="mobileOpen ? 'fa-xmark' : 'fa-bars'"
        aria-hidden="true"
      ></i>
    </button>

    <!-- [sc-48951] Non più l'elenco di dove sei, ma **una** via d'uscita e la
         pagina aperta. L'elenco intero metteva in fila tre frecce su una
         pagina profonda: tre comandi da leggere per sceglierne uno. Quella
         che serve è la più vicina, e ai livelli di sopra si arriva dalla
         sidebar o un passo per volta.

         Il tasto «Indietro» dentro la pagina era stato tolto perché faceva il
         doppio delle briciole: adesso sono le briciole a fare da tasto
         indietro, e il comando resta comunque uno solo. -->
    <nav
      v-if="!$route.meta.hideUrlIndex && (padre || corrente)"
      class="plus-topbar__breadcrumb"
      aria-label="Percorso"
    >
      <router-link
        v-if="padre"
        :to="padre.path"
        class="plus-topbar__crumb-link"
      >
        <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
        <span>{{ ritorno(padre.name) }}</span>
      </router-link>
      <span
        v-if="padre && corrente"
        class="plus-topbar__crumb-sep"
        aria-hidden="true"
        >›</span
      >
      <span v-if="corrente" class="plus-topbar__crumb-current">{{
        corrente.name
      }}</span>
    </nav>

    <div class="plus-topbar__who">
      <!-- Il nome apre la pagina Account. [sc-48351 / task 48786] Per tutti:
           agli altri ruoli Account mostra il cambio password e il conteggio
           degli operatori, la gestione resta all'amministratore. -->
      <router-link
        to="/home/account"
        class="plus-topbar__account"
        title="Vai alla pagina Account"
      >
        <i class="fa-solid fa-circle-user" aria-hidden="true"></i>
        <span class="plus-topbar__who-name">{{ operatorName }}</span>
      </router-link>
      <span class="plus-topbar__plan" title="Piano dell'azienda">PLUS</span>
    </div>
  </header>
</template>

<script>
import { breadcrumbsFor, etichettaRitorno } from "@/utilities/layoutPlus";

export default {
  name: "PlusTopBar",
  props: {
    mobileOpen: { type: Boolean, default: false },
  },
  emits: ["toggle-mobile"],
  methods: {
    ritorno: etichettaRitorno,
  },
  computed: {
    /** Il livello subito sopra: la via d'uscita. Sulla Home non c'è. */
    padre() {
      return this.breadcrumbs[this.breadcrumbs.length - 2] || null;
    },

    /** La pagina aperta: resta testo, perché a dove sei già non si torna. */
    corrente() {
      return this.breadcrumbs[this.breadcrumbs.length - 1] || null;
    },

    breadcrumbs() {
      return breadcrumbsFor(
        this.$route,
        this.$store.getters["company/branding"]?.productCategories
      );
    },

    operatorName() {
      return this.$store.state.currentUser?.operatorName ?? "";
    },
  },
};
</script>
